function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React, { useContext } from "react";
import { useUIDSeed } from "react-uid";
import { LinkContext } from "../../../context";
import { twMerge } from "../../../utils";
import { Body, Subheading } from "../../atoms";
export function ArticleDetails(param) {
    var info = param.info, tags = param.tags, shareButtons = param.shareButtons, className = param.className;
    var seed = useUIDSeed();
    var LinkComponent = useContext(LinkContext).LinkComponent;
    return /*#__PURE__*/ React.createElement("div", {
        className: twMerge("flex items-center justify-between", className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center"
    }, info === null || info === void 0 ? void 0 : info.map(function(text) {
        return /*#__PURE__*/ React.createElement(Subheading, {
            key: seed(text),
            className: "mr-5"
        }, text);
    }), tags === null || tags === void 0 ? void 0 : tags.map(function(_param) /*#__PURE__*/ {
        var label = _param.label, tag = _objectWithoutProperties(_param, [
            "label"
        ]);
        return React.createElement(LinkComponent, _extends({
            key: seed(tag)
        }, tag, {
            className: "block px-2 py-1 border border-fg-inbetween mr-5"
        }), /*#__PURE__*/ React.createElement(Body, {
            variant: "small",
            className: "text-fg-inbetween"
        }, label));
    })), /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center"
    }, shareButtons === null || shareButtons === void 0 ? void 0 : shareButtons.map(function(btn) {
        return /*#__PURE__*/ React.createElement("span", {
            key: seed(btn),
            className: "ml-5 text-fg-inbetween"
        }, btn);
    })));
}

//# sourceMappingURL=ArticleDetails.js.map